import React from 'react';
import { LogoMark } from '../brand/Logo';
import { Spinner } from '../ui/spinner';

export const FullPageLoader: React.FC<{ label?: string }> = ({ label = 'Loading your workspace…' }) => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-5 animate-fade-in">
    <LogoMark className="size-11" />
    <div className="flex items-center gap-2.5 text-[13px] text-fg-subtle">
      <Spinner className="size-4" label={label} />
      {label}
    </div>
  </div>
);
